import { useTranslation } from 'next-i18next'
import { type SetStateAction, useEffect } from 'react'
import { InView } from 'react-intersection-observer'

import { getSearchTypeWithKeywords } from '@/domain/srp/getSearchTypeWithKeywords'
import { trackEvent } from '@/lib/ga'
import { GA_EVENT } from '@/lib/ga/constants/gaEvent'
import { BodyText } from '@/ui/atoms/body-text'
import { Button } from '@/ui/atoms/button'
import { Spacing } from '@/ui/atoms/spacing'
import { colors } from '@/ui/theme/colors'
import { spacing } from '@/ui/theme/spacing'

import { CasBackfillsPanelContainer } from './styled'

type CasBackfillsPanelContainerProps = {
  setShowCasBackfills: (value: SetStateAction<boolean>) => void
  searchKeywords: string
}

export const CasBackfillsPanel = ({
  setShowCasBackfills,
  searchKeywords,
}: CasBackfillsPanelContainerProps) => {
  const { t } = useTranslation(['srp', 'common'])

  useEffect(() => {
    // fire event to show that the backfills panel was displayed
    trackEvent({
      action: GA_EVENT.CasBackfillsShowMoreLoad,
      customParameters: { eventCategory: getSearchTypeWithKeywords(searchKeywords) },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClick = () => {
    setShowCasBackfills(true)
    trackEvent({
      action: GA_EVENT.CasBackfillsShowMore,
      customParameters: { eventCategory: getSearchTypeWithKeywords(searchKeywords) },
    })
  }

  const handleInViewChange = (inView: boolean) => {
    if (inView) {
      trackEvent({
        action: GA_EVENT.CasBackfillsShowMoreView,
        customParameters: { eventCategory: getSearchTypeWithKeywords(searchKeywords) },
      })
    }
  }

  return (
    <CasBackfillsPanelContainer>
      <div>
        <InView onChange={handleInViewChange} />
        <Spacing mBottom={spacing.default}>
          <BodyText color={colors.white} size="large">
            {t('srp:cas.panel.first_line')}
          </BodyText>
        </Spacing>

        <BodyText color={colors.white} size="large">
          {t('srp:cas.panel.second_line')}
        </BodyText>
      </div>

      <Button onClick={handleClick} variant="secondary" size="small">
        {t('common:show.more')}
      </Button>
    </CasBackfillsPanelContainer>
  )
}
